var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:{ 'no-scroll': _vm.withSidebar, 'noise-texture': _vm.withSidebar }},[_c('div',{class:{ 'with-sidebar': _vm.withSidebar },attrs:{"id":"app"}},[(_vm.withSidebar)?_c('Sidebar',{staticClass:"main-sidebar"}):_vm._e(),_c('router-view',{class:[
        _vm.$route.meta.darkBackground ? 'dark-page-container' : 'page-container'
      ]})],1),_c('tooltip')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }